import { RootState } from '../../../app/store/utils/redux.types';
import { LeftPanelState } from './left-panel.slice';

export function leftPanelStateSelector(state: RootState): LeftPanelState {
  return state.leftPanel;
}
